<template>
  <div
    v-if="isRender"
    class="dialog-mask"
    :style="{ zIndex: zIndex, opacity: isShow ? 1 : 0 }"
    @click="closeOnClickMask ? hide() : null"
  >
    <div
      :class="[
        'dialog-card',
        position === 'bottom' ? 'dialog-card--bottom' : 'dialog-card--center',
        isShow ? 'dialog-card--show' : ''
      ]"
      :style="{ zIndex: zIndex + 1 }"
      @click.stop
    >
      <div v-if="closeable" class="dialog-close" @click="hide">
        <span class="vux-close"></span>
      </div>
      <slot></slot>
      <div v-if="position === 'bottom'" style="height: env(safe-area-inset-bottom, 0);"></div>
    </div>
  </div>
</template>

<script>

let dialogZIndex = 1000

const getDialogZIndex = () => {
  dialogZIndex += 2
  return dialogZIndex
}

export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'center'
    },
    closeable: {
      type: Boolean,
      default: true
    },
    closeOnClickMask: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      zIndex: 1000,
      isRender: false,
      isShow: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.isRender = val
        requestAnimationFrame(() => {
          this.isShow = val
        })
      } else {
        this.isShow = val
        setTimeout(() => {
          this.isRender = val
        }, 200)
      }
    }
  },
  methods: {
    hide() {
      this.$emit('update:visible', false)
    },
    show() {
      this.$emit('update:visible', true)
      this.zIndex = getDialogZIndex()
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;

.dialog {
  &-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.2s;
  }

  &-card {
    position: absolute;
    transition: all 0.2s;
    &--center {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &--bottom {
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(100%);
      background: #fff;
      border-radius: 24/@w2 24/@w2 0 0;
    }
    &--show.dialog-card--bottom {
      transform: translateY(0);
    }
  }

  &-close {
    position: absolute;
    width: 36/@w2;
    height: 36/@w2;
    top: 28/@w2;
    right: 28/@w2;
    cursor: pointer;

    .vux-close {
      width: 36/@w2;
      height: 36/@w2;
    }
  }
}
</style>
